<script>

export default {
  name: 'LegalDocuments',

  computed: {
    legalDocuments () {
      const docs = []
      if (!this.teamsiteConfig) {
        return docs
      }
      if (this.teamsiteConfig.participation_pdf) {
        docs.push(this.teamsiteConfig.participation_pdf)
      }
      if (this.teamsiteConfig.insurance_pdf) {
        docs.push(this.teamsiteConfig.insurance_pdf)
      }
      if (this.teamsiteConfig.fueling_pdf) {
        docs.push(this.teamsiteConfig.fueling_pdf)
      }
      if (this.generalBusinessTermsDocument) {
        docs.push(this.generalBusinessTermsDocument)
      }
      return docs
    },

    sizeClass () {
      return `small-24 large-${24 / Math.min(4, this.legalDocuments.length)}`
    },

    wrapperClass () {
      if (this.legalDocuments.length == 2) {
        return 'columns mediumlarge-20 mediumlarge-offset-2 large-18 large-offset-3'
      }
      return 'columns'
    }
  }
}
</script>

<template>
  <div v-if="legalDocuments.length > 0" class="legal-documents">

    <div class="row">
      <div :class="[wrapperClass]">
        <h3>{{ $t('legal_documents.title') }}</h3>

        <div class="row">
          <legal-document :class="['column', sizeClass]" v-for="(legalDocument, index) in legalDocuments" :legalDocument="legalDocument" :key="index"></legal-document>
        </div>

      </div>
    </div>

  </div>
</template>

<style lang="scss" scoped>
.legal-documents {
  background-color: #fff;
  padding-bottom: rem-calc(30);
  h3 {
    text-align: center;
    margin-top: rem-calc(50);
    margin-bottom: rem-calc(40);
    font-weight: bold;
  }
  .document {
    float: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LegalDocuments.vue